import React from "react"
import Layout from "../components/layout";
import Header from "../components/Header/Header";
import About from "../components/About/About"
import Experience from "../components/Experience/Experience";
import Video from "../components/Video/Video";
import Skills from "../components/Skills/Skills";
import Contact from "../components/Contact/Contact";

const IndexPage = () => {

    return (
        <Layout>
            <Header/>
            <About/>
            <Experience/>
            <Video/>
            <Skills/>
            <Contact/>
        </Layout>
    );
}

export default IndexPage;

